import md5 from 'js-md5'
import bykApi from '../bykApi';
import global from '../global/global.js'

//提交请求的参数封装
const fReqParam = (jo) => {
  let smPayAdmin =  global.fGetByPayAdmin()

	let postTime = bykApi.timeHelper.fGetNowTime(2)
	//1.请求参数转成base64
	let postJsonStr = JSON.stringify(jo);
	let base64Str = Base64.encode(postJsonStr);

	//2.组装md5签名
  let userSign =''
	let orgSk //bykApi.global.fGetByPayAdmin().orgInfo.orgSk;

  if(jo.API_NAME=='smPayAdminApi'){
    jo.API_USER_PHONE =  jo.API_USER_PHONE || "160595"
    jo.API_USER_ID =  jo.API_USER_ID || "160595"
    orgSk = "31bf9639ff5a91706f5d9a8d85ee373c"
  }else{
    orgSk =jo.API_REQ_ORG_SK;
  }
  if( !bykApi.smCom.fSmIsEmpty(orgSk)){
    userSign = orgSk + base64Str + postTime + orgSk;
    userSign = md5(userSign);
    userSign = userSign.toLowerCase();
  }


	//3.组装公用请求参数
	let postJson = {};

	postJson['POST_TIME'] = postTime;
	postJson['METHOD_NAME'] = jo.METHOD_NAME;
	postJson['REQ_JSON_STR'] = base64Str;
	postJson['API_NAME'] = jo.API_NAME;
	postJson['API_USER_PHONE'] = jo.API_USER_PHONE ;
  postJson['API_USER_ID'] = jo.API_USER_ID;
	postJson['API_REQ_FROM'] = 'smPayAdmin';
	postJson['API_REQ_TOKEN'] = jo.API_REQ_TOKEN || 'SMPAY';
  postJson['API_RANDOM_STR'] = smPayAdmin.orgUserInfo.login_only;
  postJson['API_REQ_ORG_AK'] = '4cecbf1e0d9ecda88c1b0fbfb0390ed1';
  postJson['API_REQ_SIGN'] = userSign;
  postJson['API_REQ_TIME'] = postTime;
  console.log(postJson)
	return postJson;
};


export default {
	fReqParam, //提交请求的参数封装
};



// WEBPACK FOOTER //
// ./src/common/requset/reqParm.js